export class UserPermissions {
	/////////INTRANET PERMISSIONS/////////

	// MENU: Programmazione > Servizi //
	// NOTE: Also used in Traduzioni > Servizi
	services_read: boolean = false;
	services_write: boolean = false; //old services_readwrite
	services_delete: boolean = false; //old services_readwrite
	services_articles_read: boolean = false;
	services_attributes_read: boolean = false;
	services_attributes_write: boolean = false;
	services_types_read: boolean = false; //old services_types_readwrite
	services_types_write: boolean = false; //old services_types_readwrite
	services_types_delete: boolean = false;
	services_locations_read: boolean = false;
	services_locations_write: boolean = false; //old services_locations_readwrite
	services_locations_delete: boolean = false;
	services_itineraries_read: boolean = false;
	services_itineraries_write: boolean = false; //old services_itineraries_readwrite
	services_itineraries_delete: boolean = false;
	services_periods_read: boolean = false;
	services_periods_write: boolean = false; //old services_periods_readwrite
	services_periods_delete: boolean = false; //old services_periods_readwrite
	services_departures_read: boolean = false;
	services_departures_write: boolean = false; //old services_departures_readwrite
	services_departures_delete: boolean = false; //old services_departures_readwrite
	services_rules_read: boolean = false;
	services_rules_write: boolean = false; //old services_rules_readwrite
	services_rules_delete: boolean = false; //old services_rules_readwrite
	services_package_rules_read: boolean = false; //old services_rules_read
	services_package_rules_write: boolean = false; //old services_rules_readwrite
	services_package_rules_delete: boolean = false; //old services_rules_readwrite
	services_sellrules_read: boolean = false;
	services_sellrules_write: boolean = false; //old services_sellrules_readwrite
	services_sellrules_delete: boolean = false; //old services_sellrules_readwrite
	services_assoc_read: boolean = false;
	services_assoc_write: boolean = false; //old services_assoc_readwrite
	services_assoc_delete: boolean = false; //old services_assoc_readwrite
	services_contracts_read: boolean = false;
	services_contracts_write: boolean = false; //old services_contracts_readwrite
	services_contracts_delete: boolean = false; //old services_contracts_readwrite
	services_costs_read: boolean = false;
	services_costs_write: boolean = false;
	services_costs_delete: boolean = false;

	// MENU: Programmazione > Anticipi Fornitore //
	advance_payments_read: boolean = false; //old services_advance_payments
	advance_payments_write: boolean = false; // old services_advance_payments_readwrite
	advance_payments_delete: boolean = false; // old services_advance_payments_readwrite

	// MENU: Programmazione > Margini Servizi //
	services_margins_read: boolean = false; //old services_margins
	services_margins_write: boolean = false; // old services_margins_readwrite
	services_margins_delete: boolean = false; // old services_margins_readwrite

	// MENU: Programmazione > Articoli //
	// NOTE: Also used in Traduzioni > Articoli
	articles_read: boolean = false; //old articles
	articles_write: boolean = false;
	articles_delete: boolean = false;

	// MENU: Programmazione > Frasi //
	// NOTE: Also used in Traduzioni > Frasi
	phrases_read: boolean = false; //old frasi
	phrases_write: boolean = false; //old frasi_readwrite
	phrases_delete: boolean = false;

	// MENU: Programmazione > Testi //
	texts_read: boolean = false; //old testi
	texts_write: boolean = false; // old testi_readwrite
	texts_delete: boolean = false; // old testi_readwrite

	// MENU: Programmazione > Dati Aggiuntivi //
	additional_data_read: boolean = false;
	additional_data_write: boolean = false;
	additional_data_delete: boolean = false;

	// MENU: Programmazione > Tipo Dati Aggiuntivi //
	additional_data_type_read: boolean = false;
	additional_data_type_write: boolean = false;
	additional_data_type_delete: boolean = false;

	// MENU: Programmazione > Immagini //
	media_read: boolean = false; //old images
	media_write: boolean = false;
	media_delete: boolean = false;

	// MENU: Programmazione > Check Prezzi //
	pricecheck_read: boolean = false; //old dev
	pricecheck_write: boolean = false; //old dev
	pricecheck_delete: boolean = false; //old dev

	// MENU: Traduzioni > Labels //
	labels_read: boolean = false; //old websitelabels_readwrite
	labels_write: boolean = false; //old websitelabels_readwrite | websitelabels_createdelete
	labels_delete: boolean = false; //old websitelabels_createdelete

	// MENU: Anagrafiche > Accordi //
	contracts_read: boolean = false;
	contracts_write: boolean = false; //old contracts_readwrite
	contracts_delete: boolean = false; //old contracts_readwrite
	contracts_contractors_read: boolean = false; //old contracts_contractors_readwrite
	contracts_costtabs_read: boolean = false;
	contracts_costtabs_write: boolean = false; //old contracts_costtabs_readwrite
	contracts_costtabs_delete: boolean = false;
	contracts_additionaldata_read: boolean = false;
	contracts_additionaldata_write: boolean = false; //old contracts_additionaldata_readwrite
	contracts_additionaldata_delete: boolean = false;
	contracts_suppliers_write: boolean = false; //old contracts_suppliers_readwrite

	// MENU: Anagrafiche > Aeroporti //
	airports_read: boolean = false;
	airports_write: boolean = false;
	airports_delete: boolean = false;

	// MENU: Anagrafiche > Compagnie Aeree //
	airlines_read: boolean = false;
	airlines_write: boolean = false;
	airlines_delete: boolean = false;

	// MENU: Anagrafiche > Contatti //
	contacts_read: boolean = false; //old contacts
	contacts_write: boolean = false; //old contacts_readwrite
	contacts_delete: boolean = false; //old contacts_readwrite
	contacts_maps_read: boolean = false; //old contacts_maps_readwrite
	contacts_maps_write: boolean = false; //old contacts_maps_readwrite
	contacts_maps_delete: boolean = false;
	contacts_contracts_read: boolean = false; //old contacts_contracts_readwrite
	contacts_contracts_write: boolean = false; //old contacts_contracts_readwriteù
	contacts_contracts_delete: boolean = false; //old contacts_contracts_readwrite
	contacts_addresses_read: boolean = false; //old contacts_addresses_readwrite
	contacts_addresses_write: boolean = false; //old contacts_addresses_readwrite
	contacts_addresses_delete: boolean = false; //old contacts_addresses_readwrite
	contacts_relations_read: boolean = false; //old contacts_relations_readwrite
	contacts_relations_write: boolean = false; //old contacts_relations_readwrite
	contacts_relations_delete: boolean = false; //old contacts_relations_readwrite
	contacts_data_read: boolean = false; //old contacts_data_readwrite
	contacts_data_write: boolean = false; //old contacts_data_readwrite
	contacts_data_delete: boolean = false; //old contacts_data_readwrite
	contacts_users_read: boolean = false;
	contacts_users_write: boolean = false;
	contacts_users_delete: boolean = false;

	// MENU: Anagrafiche > Luoghi //
	places_read: boolean = false; //old places
	places_write: boolean = false; //old places_readwrite
	places_delete: boolean = false; //old places_readwrite

	// MENU: Biglietteria > Emissioni //
	tickets_issuing_read: boolean = false; //old biglietteria_emissioni_read biglietteria_emissioni_okcontabilita
	tickets_issuing_write: boolean = false; //old biglietteria_emissioni_readwrite
	tickets_issuing_delete: boolean = false; //old biglietteria_emissioni_readwrite

	// MENU: Statistiche > Situazione Vendite //
	monthly_sales_read: boolean = false; //old stats_venditemese

	// MENU: Statistiche > Vendite Preventivi //
	sales_read: boolean = false; //old stats_vendite
	quotes_read: boolean = false; //old	stats_preventivi_prod && stats_preventivi these were always together;

	// MENU: Statistiche > Statistiche //
	stats_read: boolean = false; //old stats_statistiche

	// MENU: Statistiche > Reports //
	reports_read: boolean = false; //old reports
	reports_write: boolean = false;
	reports_delete: boolean = false;

	// MENU: Statistiche > Gestione Statistiche //
	stats_management_read: boolean = false; //old dev
	stats_management_write: boolean = false; //old dev
	stats_management_delete: boolean = false; //old dev

	// MENU: Statistiche > Offerte Incomplete //
	incomplete_offers_read: boolean = false; //old offerte_incomplete

	// MENU: Sales > Attività Contatti //
	contacts_activities_read: boolean = false;
	contacts_activities_write: boolean = false;
	contacts_activities_delete: boolean = false;

	// MENU: Sales > Database agenzie //
	contacts_agencies_data_read: boolean = false;
	contacts_agencies_data_write: boolean = false;
	contacts_agencies_data_delete: boolean = false;

	// MENU: Sales > Meeting Contatti //
	contacts_meetings_read: boolean = false;
	contacts_meetings_write: boolean = false;
	contacts_meetings_delete: boolean = false;

	// MENU: Contabilita > Cambi Valute //
	currencies_read: boolean = false;
	currencies_write: boolean = false; //old currencies_readwrite

	// MENU: Contabilita > Saldi //
	receipts_read: boolean = false; //old incassi
	receipts_write: boolean = false; //old incassi
	receipts_delete: boolean = false; //old incassi

	// MENU: Contabilita > Fatture //
	invoices_read: boolean = false; //old contab_fatture && contab_fatture_read
	invoices_write: boolean = false; //old contab_fatture_readwrite
	invoices_delete: boolean = false; //old contab_fatture_readwrite

	// MENU: Contabilita > Import Meridiano //
	tickets_imports_read: boolean = false; //old import_tickets
	tickets_imports_write: boolean = false; //old import_tickets

	// MENU: Contabilita > Estratto Conto //
	statements_read: boolean = false; //old contab_estattoconto

	// MENU: Contabilita > Ciclo Passivo //
	passive_read: boolean = false; //old contab_ciclopassivo
	passive_write: boolean = false; //old contab_ciclopassivo old payments_readwrite
	passive_delete: boolean = false; //old contab_ciclopassivo old payments_readwrite

	// MENU: Contabilita > Report Anticipi //
	// NOTE: Also checked in Admin menu visibility (hideAdmin)
	payments_read: boolean = false; //old payments

	// MENU: Contabilita > SEPA RID //
	sepa_rid_read: boolean = false; //old contab_fatture && contab_fatture_read
	sepa_rid_write: boolean = false;
	sepa_rid_delete: boolean = false;

	// MENU: Admin > Errori //
	admin_errors: boolean = false;

	// MENU: Admin > AI Tuning //
	admin_ai_tuning: boolean = false;

	// MENU: Admin > Activity Logs //
	admin_activity_logs: boolean = false;

	// MENU: Admin > Assicurazioni //
	admin_insurances: boolean = false; //old insurances

	// MENU: Admin > Payment Terms //
	payment_terms_read: boolean = false; //old dev
	payment_terms_write: boolean = false; //old dev
	payment_terms_delete: boolean = false; //old dev

	// MENU: Admin > Pricing //
	pricing_read: boolean = false; //old dev
	pricing_write: boolean = false; //old dev
	pricing_delete: boolean = false; //old dev

	// MENU: Admin > Fornitori H2H //
	h2h_read: boolean = false; //old h2h
	h2h_write: boolean = false; //old h2h

	// MENU: Admin > Luoghi H2H //
	h2h_locations_read: boolean = false; //old h2hlocations
	h2h_locations_write: boolean = false; //old h2hsvcs_readwrite
	h2h_locations_delete: boolean = false; //old h2hsvcs_readwrite

	// MENU: Admin > Servizi H2H (Naar) //
	naar_h2h_services_read: boolean = false; //old h2hsvcs_read
	naar_h2h_services_write: boolean = false; //old h2hsvcs_readwrite
	naar_h2h_services_delete: boolean = false; //old h2hsvcs_readwrite

	// MENU: Admin > Immagini H2H //
	naar_h2h_images_read: boolean = false;
	naar_h2h_images_write: boolean = false;
	naar_h2h_images_delete: boolean = false;

	// MENU: Admin > Descrizioni H2H //
	naar_h2h_descriptions_read: boolean = false;
	naar_h2h_descriptions_write: boolean = false;
	naar_h2h_descriptions_delete: boolean = false;

	// MENU: Admin > Servizi Fornitore //
	h2h_services_read: boolean = false; //old h2hsvcs_read
	h2h_services_write: boolean = false; //old h2hsvcs_readwrite
	h2h_services_delete: boolean = false; //old h2hsvcs_readwrite

	// MENU: Admin > Tasks Logs //
	admin_tasks_logs: boolean = false;

	// MENU: Admin > Email di Sistema //
	system_emails_read: boolean = false; //old dev
	system_emails_write: boolean = false; //old dev
	system_emails_delete: boolean = false; //old dev

	// MENU: Admin > Utenti //
	users_read: boolean = false; //old users
	users_write: boolean = false; //old users_readwrite
	users_delete: boolean = false; //old users_readwrite
	users_impersonate: boolean = false;

	// MENU: Admin > Utenti > Teams //
	admin_teams_read: boolean = false;
	admin_teams_write: boolean = false;
	admin_teams_delete: boolean = false;

	// MENU: Admin > Utenti > Roles //
	admin_roles_read: boolean = false;
	admin_roles_write: boolean = false;
	admin_roles_delete: boolean = false;

	// MENU: Admin > Email Forwarder //
	email_forwarder_read: boolean = false; //old queues

	// MENU: CMS > B2B //
	links_b2b_read: boolean = false; //old links
	links_b2b_write: boolean = false; //old links_readwrite
	links_b2b_delete: boolean = false; //old links_readwrite

	// MENU: CMS > B2C //
	links_b2c_read: boolean = false; //old links
	links_b2c_write: boolean = false; //old links_readwrite
	links_b2c_delete: boolean = false; //old links_readwrite

	// Admin general permissions //
	admin_read: boolean = false;
	admin_logged_users: boolean = false;
	admin_cache: boolean = false;
	maintenance: boolean = false;

	// Operators permissions (Anagrafiche > Operatori) //
	//TM is this component used?
	operators_read: boolean = false;
	operators_write: boolean = false;

	// AI Chat permission //
	ai_chat: boolean = false;

	// Intranet permission //
	intranet: boolean = false;

	/// B2B PERMISSIONS ///
	offert_canaskemit: boolean = false;
	offert_managepayments: boolean = false;
	offert_managetickets: boolean = false;
	offert_edit_insur_confirmed: boolean = false;
	incassi_readwrite: boolean = false;
	offert_translatable_docs: boolean = false;
	articles: boolean = false;
	dev: boolean = false;
}
